import { render, staticRenderFns } from "./resturantReport.vue?vue&type=template&id=f06eea4c&"
import script from "./resturantReport.vue?vue&type=script&lang=js&"
export * from "./resturantReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports